import { createSlice } from '@reduxjs/toolkit';

export const imageSlice = createSlice({
  name: 'image',
  initialState: {
    title: 'Qroq-The best qr code generator app ever',
    titleFont: 'Arial',
    website: 'https://qroq.in/',
    files: [],
    links: [],
    overlayTexts:[],
    overlayTextColors: [],
    overlayBackgroundColors: [],
    overlayOpacities: [],
    overlayPositions: [],
    additionalText: '',
    showAdditionalText: false,
    showAsButton: false,
    buttonBgColor: '#000000',
    buttonTextColor: '#ffffff',
    buttonBold: false,
    buttonItalic: false,
    buttonPadding: '10px 20px',
    buttonBorderRadius: '5px',
    buttonFontSize: '16px',
    buttonWidth: '120px',
    buttonHeight: '40px',
    buttonBorder: false,
    buttonBorderColor: '#000000',
    buttonBorderWidth: '1px',
    showBackground: false,
    backgroundColor: '#0986FB',
    backgroundWidth: '100%',
    backgroundHeight: 'auto',
    backgroundOpacity: '1',
    selectedFont: 'Arial',
    imagesBackgroundColor: '#ffffff',
  },
  reducers: {
    setImageField(state, action) {
      state[action.payload.key] = action.payload.val;
    },
    setImages(state, action) {
      switch (action.payload.method) {
        case 'add':
          state.files.push(action.payload.file);
          state.links.push('');
          state.overlayTexts.push('');
          state.overlayTextColors.push('#000000');
          state.overlayBackgroundColors.push('#E0F0FF');
          state.overlayOpacities.push('0.5');
          state.overlayPositions.push('bottom-center');
          return;
        case 'remove':
          state.files.splice(action.payload.id, 1);
          state.links.splice(action.payload.id, 1);
          state.overlayTexts.splice(action.payload.id, 1);
          state.overlayTextColors.splice(action.payload.id, 1);
          state.overlayBackgroundColors.splice(action.payload.id, 1);
          state.overlayOpacities.splice(action.payload.id, 1);
          state.overlayPositions.splice(action.payload.id, 1);
          return;
        default:
          return;
      }
    },
    setImageLink(state, action) {
      state.links[action.payload.id] = action.payload.link;
    },
    setOverlayText(state, action) {
      state.overlayTexts[action.payload.id] = action.payload.text;
    },
    setOverlayTextColor(state, action) {
      state.overlayTextColors[action.payload.id] = action.payload.color;
    },
    setOverlayBackgroundColor(state, action) {
      state.overlayBackgroundColors[action.payload.id] = action.payload.color;
    },
    setOverlayOpacity(state, action) {
      state.overlayOpacities[action.payload.id] = action.payload.opacity;
    },
    setOverlayPosition(state, action) {
      state.overlayPositions[action.payload.id] = action.payload.position;
    },
    initializeImageFiles(state) {
      state.files = [];
      state.links = [];
      state.overlayTexts = [];
      state.overlayTextColors = [];
      state.overlayBackgroundColors = [];
      state.overlayOpacities = [];
      state.overlayPositions = [];
    },
    initializeImages(state) {
      state.title = 'Qroq-The best qr code generator app ever';
      state.website = 'https://qroq.in/';
      state.files = [];
      state.links = [];
      state.overlayTexts = [];
      state.overlayTextColors = [];
      state.overlayBackgroundColors = [];
      state.overlayOpacities = [];
      state.overlayPositions = [];
      state.additionalText = '';
      state.showAdditionalText = false;
      state.showAsButton = false;
      state.buttonBgColor = '#000000';
      state.buttonTextColor = '#ffffff';
      state.buttonBold = false;
      state.buttonItalic = false;
      state.buttonPadding = '10px 20px';
      state.buttonBorderRadius = '5px';
      state.buttonFontSize = '16px';
      state.buttonWidth = '120px';
      state.buttonHeight = '40px';
    },
    setAdditionalText(state, action) {
      state.additionalText = action.payload.text;
    },
    setShowAdditionalText(state, action) {
      state.showAdditionalText = action.payload.show;
    },
    setShowAsButton(state, action) {
      state.showAsButton = action.payload.show;
    },
    setButtonBgColor(state, action) {
      state.buttonBgColor = action.payload.color;
    },
    setButtonTextColor(state, action) {
      state.buttonTextColor = action.payload.color;
    },
    setButtonBold(state, action) {
      state.buttonBold = action.payload.bold;
    },
    setButtonItalic(state, action) {
      state.buttonItalic = action.payload.italic;
    },
    setButtonPadding(state, action) {
      state.buttonPadding = action.payload.padding;
    },
    setButtonBorderRadius(state, action) {
      state.buttonBorderRadius = action.payload.borderRadius;
    },
    setButtonFontSize(state, action) {
      state.buttonFontSize = action.payload.fontSize;
    },
    setButtonWidth(state, action) {
      state.buttonWidth = action.payload.width;
    },
    setButtonHeight(state, action) {
      state.buttonHeight = action.payload.height;
    },
    setButtonBorder(state, action) {
      state.buttonBorder = action.payload.border;
    },
    setButtonBorderColor(state, action) {
      state.buttonBorderColor = action.payload.color;
    },
    setButtonBorderWidth(state, action) {
      state.buttonBorderWidth = action.payload.width;
    },
    setShowBackground(state, action) {
      state.showBackground = action.payload.show;
    },
    setBackgroundColor(state, action) {
      state.backgroundColor = action.payload.color;
    },
    setBackgroundWidth(state, action) {
      state.backgroundWidth = action.payload.width;
    },
    setBackgroundHeight(state, action) {
      state.backgroundHeight = action.payload.height;
    },
    setBackgroundOpacity(state, action) {
      state.backgroundOpacity = action.payload.opacity;
    },
    setSelectedFont(state, action) {
      state.selectedFont = action.payload.font;
    },
    setTitleFont(state, action) {
      state.titleFont = action.payload.font;
    },
    setImagesBackgroundColor(state, action) {
      state.imagesBackgroundColor = action.payload.color;
    },
  },
});

export const {
  setImageField,
  setImages,
  setImageLink,
  setOverlayText,
  setOverlayTextColor,
  setOverlayBackgroundColor,
  setOverlayOpacity,
  setOverlayPosition,
  initializeImageFiles,
  initializeImages,
  setAdditionalText,
  setShowAdditionalText,
  setShowAsButton,
  setButtonBgColor,
  setButtonTextColor,
  setButtonBold,
  setButtonItalic,
  setButtonPadding,
  setButtonBorderRadius,
  setButtonFontSize,
  setButtonWidth,
  setButtonHeight,
  setButtonBorder,
  setButtonBorderColor,
  setButtonBorderWidth,
  setShowBackground,
  setBackgroundColor,
  setBackgroundWidth,
  setBackgroundHeight,
  setBackgroundOpacity,
  setSelectedFont,
  setTitleFont,
  setImagesBackgroundColor,
} = imageSlice.actions;

export default imageSlice.reducer;